import { render, staticRenderFns } from "./IdeaSharingIcon.vue?vue&type=template&id=54520248&scoped=true&"
import script from "./IdeaSharingIcon.vue?vue&type=script&lang=ts&"
export * from "./IdeaSharingIcon.vue?vue&type=script&lang=ts&"
import style0 from "./IdeaSharingIcon.vue?vue&type=style&index=0&id=54520248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54520248",
  null
  
)

export default component.exports